module.exports = __webpack_public_path__ + "static/media/logo-chorinitia-1.290c3217.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperAdminPage/internalComponents/logo-chorinitia-1.jpg
// module id = 200
// module chunks = 0